import { render, staticRenderFns } from "./search-adverts-list-bookmark.vue?vue&type=template&id=18132709"
import script from "./search-adverts-list-bookmark.vue?vue&type=script&lang=ts"
export * from "./search-adverts-list-bookmark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports